export enum RoutesAddressFullEnum {
  ADDRESS_HOME = 'domicilio-particular-full' as any,
  ADDRESS_PROOF = 'comprobante-domicilio-full' as any,
  DELIVERY_ADDRESS = 'domicilio-recibir-tarjeta-full' as any,
  ADDRESS_PROOF_FACEBOOK = 'comprobante-domicilio-facebook-full' as any
}
